import React from 'react';
import PropTypes from 'prop-types';

import * as Styles from './index.styles';

const { StyledWrapper, StyledTitle, StyledIcon, StyledContentWrapper } = Styles;

export const CollapseArea = ({ children, title, initialStatus, onChange }) => {
    const [open, setOpen] = React.useState(initialStatus);

    const handleToggle = () => {
        onChange(!open);
        setOpen(prev => !prev);
    };

    return (
        <StyledWrapper>
            <StyledTitle data-test-id="collapse-area-title" onClick={handleToggle}>
                {title}
                <StyledIcon icon={open ? 'minus' : 'plus'} size="sm" />
            </StyledTitle>
            <StyledContentWrapper isOpen={open}>
                {children && open && <>{children}</>}
            </StyledContentWrapper>
        </StyledWrapper>
    );
};

CollapseArea.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    initialStatus: PropTypes.bool,
    onChange: PropTypes.func,
};

CollapseArea.defaultProps = {
    initialStatus: true,
    onChange: () => {},
};

CollapseArea.Styles = Styles;

export default CollapseArea;
